import { LANGS } from "../../i18n/translations";
import { useLang } from "../../i18n/LanguageContext";

const Flag = ({ lang }) => {
  if (lang === "sv") {
    return (
      <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
        <rect width="20" height="20" fill="#006AA7" />
        <rect x="6" width="2.8" height="20" fill="#FECC02" />
        <rect y="8.6" width="20" height="2.8" fill="#FECC02" />
      </svg>
    );
  }

  if (lang === "en") {
    return (
      <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
        <rect width="20" height="20" fill="#012169" />
        <path d="M0 0 20 20M20 0 0 20" stroke="#fff" strokeWidth="5" />
        <path d="M0 0 20 20M20 0 0 20" stroke="#C8102E" strokeWidth="2" />
        <path d="M10 0v20M0 10h20" stroke="#fff" strokeWidth="6" />
        <path d="M10 0v20M0 10h20" stroke="#C8102E" strokeWidth="3.2" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <rect width="20" height="6.67" y="0" fill="#000" />
      <rect width="20" height="6.67" y="6.67" fill="#DD0000" />
      <rect width="20" height="6.66" y="13.34" fill="#FFCE00" />
    </svg>
  );
};

export const LangSwitch = ({ idPrefix = "header" }) => {
  const { lang, setLang, t } = useLang();

  return (
    <div className="lang-switch" role="group" aria-label={t.nav.language} data-testid={`${idPrefix}-lang-switch`}>
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          className={l === lang ? "is-active" : ""}
          aria-pressed={l === lang}
          onClick={() => setLang(l)}
          data-testid={`${idPrefix}-lang-${l}`}
        >
          <span className="lang-switch__flag"><Flag lang={l} /></span>
          <span>{l.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};
